<template>
  <footer class="site-footer relative z-10">
    <div class="footer-inner">
      <div class="footer-top">
        <div class="footer-brand">
          <router-link to="/" class="footer-logo">
            <svg class="monogram" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path fill="none" stroke="#3B82F6" stroke-linecap="round" stroke-width="8" d="M30,20 L30,80 M20,80 L40,80" />
              <path fill="none" stroke="#E5E7EB" stroke-linecap="round" stroke-width="8" d="M60,20 L60,80 C75,80 80,65 80,50 C80,35 75,20 60,20 M60,50 C75,50 80,50 80,50" />
              <circle fill="#10B981" cx="50" cy="50" r="5" />
            </svg>
            <span>Jerome Brown</span>
          </router-link>
          <p class="footer-tagline">Product leader & builder</p>
        </div>

        <nav class="footer-nav" aria-label="Footer">
          <router-link to="/" class="footer-link">Home</router-link>
          <router-link to="/about" class="footer-link">About</router-link>
          <router-link to="/contact" class="footer-link">Contact</router-link>
          <a
            href="https://jeromejbrown.substack.com/"
            target="_blank"
            rel="noopener noreferrer"
            class="footer-link"
          >
            Blog
          </a>
        </nav>

        <div class="footer-contact">
          <a href="mailto:jerome@jeromejbrown.com" class="footer-email">
            jerome@jeromejbrown.com
          </a>
          <router-link to="/contact" class="footer-cta">
            Get in touch
            <i class="fas fa-arrow-right text-xs"></i>
          </router-link>
        </div>
      </div>

      <div class="footer-bottom">
        <p class="footer-copy">&copy; {{ year }} Jerome Brown. All rights reserved.</p>
        <p class="footer-built">
          Built with
          <a href="https://vuejs.org/" target="_blank" rel="noopener noreferrer" aria-label="Vue.js">
            <img src="/assets/vue.png" alt="" class="footer-tech-icon" />
            Vue
          </a>
          <span class="footer-sep">&</span>
          <a href="https://threejs.org/" target="_blank" rel="noopener noreferrer">
            Three.js
          </a>
        </p>
      </div>
    </div>
  </footer>
</template>

<script setup>
const year = new Date().getFullYear();
</script>

<style scoped>
.site-footer {
  margin-top: auto;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  background: rgba(9, 12, 20, 0.65);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
}

.footer-inner {
  max-width: 80rem;
  margin: 0 auto;
  padding: 2.5rem 1.25rem 1.75rem;
}

.footer-top {
  display: grid;
  gap: 2rem;
  margin-bottom: 2rem;
}

@media (min-width: 768px) {
  .footer-top {
    grid-template-columns: 1.2fr 1fr 1fr;
    align-items: start;
  }
}

.footer-logo {
  display: inline-flex;
  align-items: center;
  gap: 0.625rem;
  text-decoration: none;
  color: #f3f4f6;
  font-weight: 600;
  font-size: 1rem;
  transition: color 0.2s ease;
}

.footer-logo:hover {
  color: #99f6e4;
}

.monogram {
  width: 1.75rem;
  height: 1.75rem;
}

.footer-tagline {
  margin-top: 0.5rem;
  font-size: 0.875rem;
  color: #6b7280;
}

.footer-nav {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem 1.25rem;
}

@media (min-width: 768px) {
  .footer-nav {
    justify-content: center;
    padding-top: 0.25rem;
  }
}

.footer-link {
  font-size: 0.875rem;
  font-weight: 500;
  color: #9ca3af;
  text-decoration: none;
  transition: color 0.2s ease;
}

.footer-link:hover,
.footer-link.router-link-active {
  color: #5eead4;
}

.footer-contact {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

@media (min-width: 768px) {
  .footer-contact {
    align-items: flex-end;
    text-align: right;
  }
}

.footer-email {
  font-size: 0.875rem;
  color: #9ca3af;
  text-decoration: none;
  transition: color 0.2s ease;
}

.footer-email:hover {
  color: #5eead4;
}

.footer-cta {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.8125rem;
  font-weight: 600;
  color: #0f172a;
  background: #2dd4bf;
  padding: 0.5rem 1rem;
  border-radius: 9999px;
  text-decoration: none;
  width: fit-content;
  transition: background 0.2s ease;
}

.footer-cta:hover {
  background: #5eead4;
}

.footer-bottom {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding-top: 1.5rem;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
}

@media (min-width: 640px) {
  .footer-bottom {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
}

.footer-copy,
.footer-built {
  font-size: 0.8125rem;
  color: #6b7280;
  margin: 0;
}

.footer-built {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.35rem;
}

.footer-built a {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  color: #9ca3af;
  text-decoration: none;
  transition: color 0.2s ease;
}

.footer-built a:hover {
  color: #5eead4;
}

.footer-tech-icon {
  width: 1rem;
  height: 1rem;
  opacity: 0.85;
}

.footer-sep {
  color: #4b5563;
}
</style>
